(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sg-editorial-heading"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.sgEditorialHeadingFitInitialized) return;
    window.sgEditorialHeadingFitInitialized = true;

    function remToPixels(value) {
      if (!value) return 0;
      var rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
      return parseFloat(value) * rootFontSize;
    }

    function resolveSize(value, element) {
      if (!value) return 0;

      if (value.indexOf('clamp(') === 0) {
        return parseFloat(getComputedStyle(element).fontSize) || 0;
      }

      if (value.indexOf('rem') > -1) return remToPixels(value);
      if (value.indexOf('px') > -1) return parseFloat(value);

      return parseFloat(value) || 0;
    }

    function fitsHeading(element, maxWidth) {
      var words = element.querySelectorAll('.sg-editorial-heading__word');

      for (var index = 0; index < words.length; index += 1) {
        if (words[index].getBoundingClientRect().width > maxWidth + 0.5) return false;
      }

      return element.scrollWidth <= maxWidth + 1;
    }

    function fitHeading(element) {
      if (!element || element.dataset.sgFitText !== 'shrink-words') return;

      element.style.removeProperty('--sg-editorial-heading-size');

      var availableWidth = element.clientWidth;
      if (!availableWidth) return;

      var styles = getComputedStyle(element);
      var preferredSize = resolveSize(styles.getPropertyValue('--sg-editorial-heading-fluid-size').trim(), element)
        || parseFloat(styles.fontSize)
        || 0;
      var minSize = resolveSize(styles.getPropertyValue('--sg-editorial-heading-min-size').trim(), element)
        || preferredSize;

      if (!preferredSize || preferredSize <= minSize) return;

      if (fitsHeading(element, availableWidth)) return;

      var low = minSize;
      var high = preferredSize;
      var best = minSize;

      while (high - low > 0.5) {
        var mid = (low + high) / 2;
        element.style.setProperty('--sg-editorial-heading-size', mid + 'px');

        if (fitsHeading(element, availableWidth)) {
          best = mid;
          low = mid;
        } else {
          high = mid;
        }
      }

      element.style.setProperty('--sg-editorial-heading-size', best + 'px');
    }

    function fitAllHeadings() {
      var headings = document.querySelectorAll('[data-sg-fit-text="shrink-words"]');
      headings.forEach(fitHeading);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fitAllHeadings);
    } else {
      fitAllHeadings();
    }

    if ('ResizeObserver' in window) {
      var resizeObserver = new ResizeObserver(function (entries) {
        entries.forEach(function (entry) {
          fitHeading(entry.target);
        });
      });

      document.querySelectorAll('[data-sg-fit-text="shrink-words"]').forEach(function (heading) {
        resizeObserver.observe(heading);
      });
    } else {
      window.addEventListener('resize', fitAllHeadings);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
